import Vue from 'vue'
import Router from 'vue-router'
// import Home from '@/views/Home.vue'
import System from '@/views/system/system.vue'
import User from '@/views/user/User.vue'
/* eslint-disable */
Vue.use(Router)

export default new Router({
  // mode: 'history', 这个模式切换有闪烁 先不用
  // base: process.env.BASE_URL,
  //

  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/user/Login.vue')
    },
    {
      path: '/',
      name: 'home',
      // meta: basic_meta,
      component: () => import('@/views/Home.vue')
    },
    {
      path: '/about',
      name: 'about',
      // meta: basic_meta,
      component: () => import('@/views/About.vue')
    },
    {
      path: '/story',
      name: 'story',
      component: () => import('@/views/Story.vue')
    },
    {
      path: '/notify',
      name: 'notify',
      meta: {
        requiresLogin: true,
        requiredPermissions: ['checker', 'researcher', 'phone_admin', 'system_admin']
      },
      component: () => import('@/views/Notify.vue')
    },
    {
      path: '/user',
      name: 'user',
      meta: {
        requiresLogin: true,
        requiredPermissions: ['checker', 'researcher', 'phone_admin', 'system_admin']
      },
      component: User,
      children: [
        {
          path: 'changePwd',
          name: 'changePwd',
          meta: {
            requiresLogin: true,
            requiredPermissions: ['checker', 'researcher', 'phone_admin', 'system_admin']
          },
          component: () => import('@/views/user/ChangePwd.vue')
        }
      ]
    },
    {
      path: '/system',
      name: 'system',
      meta: {
        requiresLogin: true,
        requiredPermissions: ['researcher', 'phone_admin', 'system_admin']
      },
      component: System,
      children: [
        {
          path: 'cameraManage',
          name: 'cameraManage',
          meta: {
            requiresLogin: true,
            requiredPermissions: ['phone_admin', 'system_admin']
          },
          component: () => import('@/views/system/cameraManage.vue')
        },
        {
          path: 'phoneManage',
          name: 'phoneManage',
          meta: {
            requiresLogin: true,
            requiredPermissions: ['phone_admin', 'system_admin']
          },
          component: () => import('@/views/system/phoneManage.vue')
        },
        {
          path: 'userManage',
          name: 'userManage',
          meta: {
            requiresLogin: true,
            requiredPermissions: ['system_admin']
          },
          component: () => import('@/views/system/userManage.vue')
        },
        {
          path: 'userTownManage',
          name: 'userTownManage',
          meta: {
            requiresLogin: true,
            requiredPermissions: ['phone_admin', 'system_admin']
          },
          component: () => import('@/views/system/userTownManage.vue')
        },
        {
          path: 'clubStoryManage',
          name: 'clubStoryManage',
          meta: {
            requiresLogin: true,
            requiredPermissions: ['phone_admin', 'system_admin']
          },
          component: () => import('@/views/system/clubStoryManage.vue')
        },
        {
          path: 'editClubStory/:id',
          name: 'editClubStory',
          meta: {
            requiresLogin: true,
            requiredPermissions: ['phone_admin', 'system_admin']
          },
          component: () => import('@/views/system/editClubStory.vue')
        },
        {
          path: 'homeManage',
          name: 'homeManage',
          meta: {
            requiresLogin: true,
            requiredPermissions: ['phone_admin', 'system_admin']
          },
          component: () => import('@/views/system/homeManage.vue')
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
